module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-300.a1278813.woff2";